import { Container, Title, Text, Button, Group, Stack } from "@mantine/core";
import { Link } from "react-router-dom";
import { IconArrowRight } from "@tabler/icons-react";
export interface CTAButton {
  text: string;
  link: string;
  style: "primary" | "secondary";
  showIcon?: boolean;
}

export interface CTASectionProps {
  title: string;
  subtitle: string;
  buttons: CTAButton[];
}

export default function CTASection({ title, subtitle, buttons }: CTASectionProps) {
  return (
    <Container size="lg" py={100}>
      <Stack align="center" gap="xl">
        <Title order={2} ta="center" style={{ fontSize: "2.5rem", fontWeight: 700, color: "#1a202c" }}>
          {title}
        </Title>
        <Text c="slate.6" size="lg" ta="center" maw={600}>
          {subtitle}
        </Text>
        <Group
          gap="md"
          mt="md"
          justify="center"
          style={{ flexDirection: "row" }}
          styles={{ root: { "@media (maxWidth: 768px)": { flexDirection: "column" } } }}
        >
          {buttons.map((button, index) => (
            <Button
              key={index}
              component={Link}
              to={button.link}
              size="xl"
              radius="lg"
              color="primary"
              rightSection={button.showIcon ? <IconArrowRight size={18} /> : undefined}
              variant={button.style === "primary" ? "filled" : "outline"}
              styles={{
                root: {
                  paddingLeft: 30,
                  paddingRight: 30,
                  minWidth: 240,
                  ...(button.style === "secondary" && { borderWidth: 1.5 }),
                },
              }}
            >
              {button.text}
            </Button>
          ))}
        </Group>
      </Stack>
    </Container>
  );
}
